import { PATH_EVENT_ACTIVITY } from "@configs";
import { IGetEvent } from "@interfaces";
import { selectMerchant } from "@redux";
import { RenderMeta, useNotify } from "@utils";
import { Skeleton } from "antd";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { eventActivityAPI } from "src/API/eventActivity";
import styled from "styled-components";
import SwiperCore, { Autoplay, EffectCoverflow, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { EventActivityModal } from "./Modal";

import { t } from "i18next";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { ArrowLeftColor } from "../icon";
import titleEventActivity from "../icon/EventActivity/titleEventActivity.png";
import "./Swiper.css";
// import "./App.css";

SwiperCore.use([EffectCoverflow, Autoplay, Pagination]);

interface IProps {
    userInfo: any;
}

export const ComponentEventActivity = (props: IProps) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const { userInfo } = props;
    const { error } = useNotify();
    const history = useHistory();
    const orgID = useSelector(selectMerchant)._id;
    const [showButton, setShowButton] = useState<boolean>(true);
    const { id } = useParams<{ id: string }>();
    const [eventActivity, setEventActivity] = useState<IGetEvent[]>([]);
    const [eventActivityShow, setEventActivityShow] = useState<number>(0);
    const { themes } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const handleModal = () => {
        setShowModal(!showModal);
    };
    const handleDetails = () => {
        history.push(PATH_EVENT_ACTIVITY + "/details/" + eventActivity[eventActivityShow]._id);
    };

    const getEventList = async () => {
        try {
            const get = await eventActivityAPI.getEventList();
            if (get.data) {
                setEventActivity(get.data.filter((item: any) => item.isActive));
            }
        } catch (err: any) {
            err.response?.data?.message ? error(err.response?.data?.message) : error(err.message);
        }
    };

    useEffect(() => {
        // checkUser();
        getEventList();
    }, []);

    const handleSlideChange = (swiper: any) => {
        setEventActivityShow(swiper.activeIndex);
    };

    return eventActivity ? (
        <StyledContainer color={"#C4A363"} themeColor={themes?.themeColor!}>
            <RenderMeta title={t("meta.eventactivity_page")} />
            <div className="wholePage">
                <div className="backgroundImage">
                    <img src={titleEventActivity} alt="" />

                    <div className="backIcon" onClick={() => history.push("/")}>
                        <ArrowLeftColor color={themes?.themeColor} />
                        {/* <span>{t("page.back")}</span> */}
                    </div>
                </div>
                <div className="content">
                    <div className="main-swiper">
                        <Swiper
                            effect={"coverflow"}
                            // autoplay={{
                            //     delay: 3000,
                            //     disableOnInteraction: false,
                            // }}
                            grabCursor={true}
                            centeredSlides={true}
                            slidesPerView={"auto"}
                            coverflowEffect={{
                                rotate: 50,
                                stretch: 0,
                                depth: 100,
                                modifier: 1,
                                slideShadows: false,
                            }}
                            pagination={true}
                            className="mySwiper"
                            onSlideChange={handleSlideChange}
                        >
                            {/* using Array */}
                            {eventActivity.map((image, i) => {
                                return (
                                    <SwiperSlide
                                        key={i}
                                        onClick={() => console.log("first", image)}
                                    >
                                        <img
                                            src={image.coverImage[0] ? image.coverImage[0] : ""}
                                            alt=""
                                        />
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    </div>
                    <h1>{eventActivity[eventActivityShow]?.name}</h1>
                    <p>
                        EXP :{" "}
                        {format(new Date(eventActivity[eventActivityShow]?.from), "DD/MM/YYYY")} -{" "}
                        {format(new Date(eventActivity[eventActivityShow]?.till), "DD/MM/YYYY")}
                    </p>
                    <div className="buttonsColumn">
                        {eventActivity[eventActivityShow]?.usersJoin?.some(
                            (item) => item.userId === userInfo?.contact?.userId
                        ) ? (
                            <button className="blue" onClick={handleDetails}>
                                Details
                            </button>
                        ) : (
                            <button className="blue" onClick={handleModal}>
                                Join Event Now!
                            </button>
                        )}
                    </div>
                </div>
                <EventActivityModal
                    handleModal={handleModal}
                    showModal={showModal}
                    userInfo={userInfo}
                    themeColor={"#336C51"}
                    eventActivityId={eventActivity[eventActivityShow]?._id}
                    confirmationImage={eventActivity[eventActivityShow]?.confirmationImage}
                    isActive={true}
                />
            </div>
        </StyledContainer>
    ) : (
        <Skeleton />
    );
};
const StyledContainer = styled.div<{ color: string; themeColor: string }>`
    height: 100dvh;
    // background: radial-gradient(
    //     96.91% 47.07% at 50% 50%,
    //     rgba(196, 163, 99, 0) 41.16%,
    //     rgba(50, 101, 76, 0.53) 65.97%,
    //     rgba(31, 74, 53, 0.9) 100%
    // );
    background-image: url(../../images/bg-event-activityx3.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    .backgroundImage {
        padding: 50px 0;
        .backIcon {
            position: absolute;
            top: 20px;
            left: 20px;
            cursor: pointer;
            z-index: 1;
            display: flex;
            align-items: center;
            span {
                margin-left: 10px;
                color: ${(p) => p.themeColor};
            }
        }
        img {
            width: 100%;
        }
    }
    .whiteGradiant {
        background: radial-gradient(
            100% 72% at 50% 5%,
            rgba(255, 255, 255, 0) 70%,
            rgba(255, 255, 255, 0.62) 92%,
            #fff 100%
        );
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        z-index: 0;
    }
    .content {
        position: relative;
        z-index: 1;
        margin: 0 auto 16px auto;
        justify-content: center;
        align-items: center;
        margin: 0;
        .main-swiper {
            .swiper-pagination {
                display: none;
            }
            .swiper-slide {
                height: 300px;
                margin-bottom: 30px;
                display: flex;
                align-items: center;
            }
        }

        h1 {
            color: #fff;
            text-align: center;
            font-size: 20px;
            font-weight: 700;
            line-height: inherit;
            margin-bottom: 5px;
            margin-top: 30px;
        }
        p {
            color: #fff;
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            line-height: inherit;
        }
        .buttonsColumn {
            margin-top: 46px;
            display: flex;
            flex-direction: column;
            gap: 12px;
            padding: 0 30px;
            button {
                border-radius: 14px;
                border: 1px solid ${(p) => p.color || "#0573cd"};
                background: #fff;
                color: ${(p) => p.color || "#0573cd"};
                text-align: center;
                font-size: 13px;
                font-style: normal;
                font-weight: 700;
                line-height: inherit;
                padding: 14.5px 0;
                cursor: pointer;
            }
            .blue {
                border-radius: 14px;
                background: ${(p) => p.color || "#0573cd"};
                color: #fff;
            }
        }
    }
`;
